import cryptojs from "crypto-js";
import settings from "@/settings.json";

export const encrypt = (txt?: string) => {
  if (txt != null && txt != undefined) {
    return cryptojs.AES.encrypt(txt, `${settings.SecretPassphrase}`).toString();
  }
  return null;
};
